import {Button, Typography} from 'antd';
import React from 'react';

import {IErrorFormData} from '../Utils/Interfaces';

const {Title} = Typography;

const ErrorScreen: React.FC<IErrorFormData> = ({goBack}) => {
  return (
    <div className="otp-container">
      <Title level={4} style={{marginTop: -10}}>
        Your session has expired while changing the password. Please try again.
      </Title>
      <Button
        type="primary"
        block
        onClick={goBack}
        style={{
          marginTop: 20,
          height: 44,
          backgroundColor: 'rgb(21, 154, 132)',
          fontWeight: 600
        }}
      >
        Please Try Again!
      </Button>
    </div>
  );
};

export default ErrorScreen;
